import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface UserServiceConfigInterface {
  keycloakApiURL: string;
  userServiceApiURL: string;
  fairDataGatewayURL: string;
  channelsApiUrl: string;
}

export const USER_SERVICE_CONFIG = new InjectionToken<UserServiceConfigInterface>('USER_SERVICE_CONFIG');
export const USER_SESSION_STATUS = new InjectionToken<BehaviorSubject<boolean>>('USER_SESSION_STATUS');
